
app.service('topModal', function () {
    var $self;

    function generate({ content = '', header = '', cssClass = '', close = true }) {
        $self = $('<div id="top-modal" class="' + cssClass + '"><div id="top-modal-header">' + header + '</div><div id="top-modal-content">' + content + '</div>');
        if (close) {
            $self.on('click', function () {
                close();
            });
        }
        $('body').append($self);
    }
    function close() {
        $self.remove();
    }
    return {
        generate, close
    };
});
